export function getBookingAuthToken(
  customerToken: string | null,
  isCustomerLoggedIn: boolean
): string | null {
  if (!isCustomerLoggedIn) return null;
  return customerToken;
}

export function shouldClearCustomerSession(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  return Number((error as { status?: unknown }).status) === 401;
}
